import Http from 'axios'
import {
    API_URL,
    VERSION
} from '../../config/config'

function initialState() {
    return {
        visa_types: [],
        visa_type: {},
        conditions: [],
        loading: false,
        can_insert_day: false,
        first_time: false,
        overstay: false,
        free_days: 0,
        custom_conditions: [],
        //No of days in which year is completed
        //No of days in which year is completed
        min_age_days_remaining: false,
        min_age: 0,
        visa_type_slug: null,
        extend_condition: [],
        remaining_days: null,
        selected_condition: []
    }
}

const getters = {
    visa_types: state => state.visa_types,
    visa_type: state => state.visa_type,
    conditions: state => state.conditions,
    custom_conditions: state => state.custom_conditions,
    free_days: state => state.free_days,
    overstay: state => state.overstay,
    can_insert_day: state => state.can_insert_day,
    loading: state => state.loading,
    condition: state => state.selected_condition,
    min_age_days_remaining: state => state.min_age_days_remaining,
    min_age: state => state.min_age,
    visa_type_slug: state => state.visa_type_slug,
    extend_condition: state => state.extend_condition,
    remaining_days: state => state.remaining_days
};

const actions = {
    fetchConditionByVisaTypeSlug({
        commit
    }, slug) {
        Http.get(`${API_URL}${VERSION}/visa-type-condition?slug=` + slug).then((response) => {
            commit('setConditions', response.data)
        })
    },
    fetchConditionForConvert(state, data) {
        return new Promise(((resolve, reject) => {
            const visa_detail = this.getters['VisaSingle/extendConvertVisaDetail'];
            const extend_convert_data = this.getters['VisaSingle/extendConvertData'];
            Http.get(`${API_URL}${VERSION}/visa-type-convert-condition`, {
                params: {
                    visa_number: visa_detail.visa_number,
                    type: data.type,
                    token: visa_detail.token,
                    dependent_passport_number: extend_convert_data.dependent_passport_number,
                    dependent_visa_number: extend_convert_data.dependent_visa_number
                }
            }).then((response) => {
                state.commit('setConditionsOnly', response.data.conditions);
                state.commit('setConvertSlug', response.data.slug);
                if (response.data.dependent_visa) {
                    this.commit('VisaSingle/setDependentVisaDetails', response.data.dependent_visa)
                }


                resolve(true)
            }).catch((error) => {
                this.commit('Notification/showError', error.response.data.message);
                reject(error)
            })
        }))
    },
    fetchConditionsForExtend(state) {
        return new Promise(((resolve, reject) => {
            let visa_detail = this.getters['VisaSingle/extendConvertVisaDetail'];
            Http.get(`${API_URL}${VERSION}/visa-type-extend-condition`, {
                params: {
                    visa_number: visa_detail.visa_number,
                    token: visa_detail.token
                }
            }).then((response) => {
                state.commit('setExtendConditions', response.data.data);
                resolve(true)
            }).catch((error) => {
                reject(error)
            })
        }))
    },
    // fetchConditionForDocuments
    fetchCondition({
        state,
        commit
    }) {
        return new Promise((resolve, reject) => {
            let visa_detail = this.getters['VisaSingle/visa'];
            Http.get(`${API_URL}${VERSION}/visa-type-condition`, {
                params: {
                    passport_type: visa_detail.passport.passport_type,
                    passport_number: visa_detail.passport.passport_number,
                    country: visa_detail.traveller.country,
                    dob: visa_detail.traveller.dob,
                    visa_type: state.visa_type.slug,
                    not_first_time: visa_detail.traveller.not_first_time,
                    embassy_office: visa_detail.office,
                }
            }).then((response) => {
                commit('setConditions', response.data);
                resolve(response.data)
            }).catch((error) => {
                reject(error)
            })

        })
    },
    resetState({
        commit
    }) {
        commit('resetState')
    }
};

const mutations = {
    setConditions(state, item) {
        state.conditions = item.conditions;
        state.overstay = item.overstay;
        state.remaining_days = item.remaining_days;
    },
    setConditionsOnly(state, item) {
        state.conditions = item;
    },
    setExtendConditions(state, item) {
        state.extend_condition = item;
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setSelectedCondition(state, item) {
        state.selected_condition = item;
    },
    setVisaType(state, item) {
        state.visa_type = item;
    },
    setConvertSlug(state, item) {
        state.visa_type_slug = item;
    },
    setArrivalVisaTypes(state) {
        state.visa_types = [{
            type: 'Tourist Visa',
            slug: 'tourist-visa'
        }, {
            type: 'Diplomatic Visa',
            slug: 'diplomatic-visa'
        }, {
            type: 'Official Visa',
            slug: 'official-visa'
        }]
    },

    // eslint-disable-next-line no-unused-vars
    resetState(state) {
        state = Object.assign({}, initialState())
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}